import { getRoute } from '.'
import { Place } from './models'
import { platform } from './tools'

// Launch native navigation app
export const nativeDirections = async (routeId: string, from: Place, to: Place) => {  
  const route = getRoute(routeId)
  
  /*if (platform().isIOS) {  
    const vehicleConverter: any = {'foot': 'w', 'car': 'd'}
    const travelmode = vehicleConverter[route.settings.vehicle] || 'd' 
    const win = window.open(`https://maps.apple.com/?dirflg=h&daddr=${to.address}&dirflg=${travelmode}&ll=`, '_self')
    win?.focus()*/
  if (platform().isIOS) {  
    const vehicleConverter: any = {'foot': 'walking', 'car': 'driving', 'bike': 'bicycling'}  
    const travelmode = vehicleConverter[route.settings.vehicle] || 'driving'
    const win = window.open(`maps://www.google.com/maps/dir/?api=1&origin=${from.address}&destination=${to.address}&travelmode=${travelmode}&ll=`, '_top')
    win?.focus()
  } else {
    const vehicleConverter: any = {'foot': 'walking', 'car': 'driving', 'bike': 'bicycling'}  
    const travelmode = vehicleConverter[route.settings.vehicle] || 'driving'
    // const win = window.open("https://maps.google.com/maps?dirflg=h&saddr=My+Location&daddr=" + destination + "&ll=", '_blank');
    const win = window.open(`https://www.google.com/maps/dir/?api=1&origin=${from.address}&destination=${to.address}&travelmode=${travelmode}&ll=`, '_blank')
    //https://www.google.com/maps/dir/?api=1&origin=Space+Needle+Seattle+WA&destination=Pike+Place+Market+Seattle+WA&travelmode=bicycling
    win?.focus()
  }
}

export const getGoogleMapsRoutes = (places: Place[]) => {
  const sortedPlaces = places.slice(0,25)
  const urlPlaces = sortedPlaces.reduce((str, place) => str + '/' + encodeURIComponent(place.coords.lat + ',' + place.coords.lon), '')  
  const url = `https://www.google.com/maps/dir${urlPlaces}`
  // console.log(url)
  return url
}
